import {Service} from '@s-ui/domain'

/**
 * @class
 * @implements Service
 */
export default class GetAuthenticationTokenService extends Service {
  /**
   * @constructor
   * @param {Object} param
   * @param {Boolean} param.isNode
   * @param {Object} param.config
   * @param {Repository} param.localRepository
   * @param {Repository} param.remoteRepository
   * @param {GetCurrentUserService} param.getCurrentUserService
   */
  constructor({config, localRepository, remoteRepository, getCurrentUserService}) {
    super()
    this._config = config
    this._localRepository = localRepository
    this._remoteRepository = remoteRepository
    this._getCurrentUserService = getCurrentUserService
  }

  /**
   * @return {Promise<String>} authentication token
   */
  async execute() {
    const userEntity = await this._getCurrentUserService.execute()
    const userId = userEntity.getId()
    const token = userEntity.getToken()

    return this._localRepository
      .getAuthenticationToken({userId})
      .then(authenticationToken => {
        return authenticationToken || this._remoteRepository.getAuthenticationToken({userId, token})
      })
      .catch(() => this._remoteRepository.getAuthenticationToken({userId, token}))
  }
}
